import roles from '../constants/roles';

export function getProfileNumber(personalData, userRole) {
  if (userRole === +roles.installer) {
    if (
      personalData.get('address') !== '' &&
      personalData.get('company') !== '' &&
      personalData.get('vat') !== '' &&
      personalData.get('citycode')
    ) {
      return 1;
    }
  }
  return 0;
};

export function getNumberToBadge(link, alertsCount, profileNumber) {
  let ret = 0;
  if (link === '/messages') {
    ret = alertsCount.get('unseenMessages');
  } else if (link === '/notifications') {
    ret = alertsCount.get('unseenAlerts');
  } else if (link.startsWith('/profile')) {
    ret = profileNumber;
  }
  return ret;
};



// WEBPACK FOOTER //
// ./src/core/navigationHelper.js